import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const FaqId = async (id) => {
  try {
    return await getData(`/website/faq/faq/${id}`);
  } catch (error) {
    console.log(error);
  }
};


export const Faqs = async (id) => {
  try {
    return await getData(`/website/faq/faq`);
  } catch (error) {
    console.log(error);
  }
};